import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import { LayoutService } from '@app/core/services';
import { UserService } from '@app/core/services';
import { CommonService } from '@app/core/services/common.service';
import { I18nService } from '@app/shared/i18n/i18n.service';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment';
import { TutorialEventsService } from '@app/core/services/tutorial-events.service';
import { HttpClient } from '@angular/common/http';
import {LayoutService as SharedLayoutService} from "@app/shared/layout/layout.service";
import { BsModalRef,ModalDirective } from 'ngx-bootstrap';
import { EmitService } from '@app/ts/services/emit.service';
import { AppService } from '@app/app.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';
import { TemplateRef } from '@angular/core';
declare const PDFObject: any;

declare var $: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
  styleUrls:['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  // @ViewChild('previewSearchModal') public previewSearchModal: ModalDirective;
  @ViewChild('newBuild') public newBuild:ModalDirective;
  @ViewChild('legacyUpdateModal', { static: true }) public legacyUpdateModal:ModalDirective;
  public loadingTemplate: TemplateRef < any > ;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  @ViewChild('ngxLoading', {
    static: false
  }) ngxLoadingComponent: NgxLoadingComponent;
  store: any;
  light: any;
  dark: any;
  ispreviewLoading : boolean = false;
  loadedDarkOptions;
  loadedDarkprofile;
  loadedLightOptions;
  loadedLightprofile;
  lanId: any;
  company;
  langChangeSubscription: Subscription;
  langaugeChanged: boolean = false;
  activitySelected:boolean = false;
  fullScreenSelected:boolean = true;
  notificationSelected:boolean = false;
  settingsMenu = false;
  ebill_edi_nav: any;
  ebillMenu: boolean = true;
  ediMenuSelected: boolean = true;
  ebillMenuSelected: boolean = false;
  headerColor = environment.color;
  pagePermission: any;
  haseBillPermission:boolean = false;
  buildAlert:String =""
  filePath: any;
  isXml: boolean = false;
  imageData: any;
  pdfglinkSource: string;
  pdfFileName;
  configB = {
    backdrop: false,
    keyboard: false,
    ignoreBackdropClick: true
  };
  showRefreshLoader: boolean;
  hasEDIPermission: boolean = false;
  isSuccess:boolean =false;
  isErrors:boolean =false;
  alertMessage: any = "";
  ShowContract: boolean = false;
closeContract:boolean = false;
  showPreviewLoader: boolean;
showErrorContractMsg: boolean  = false;
showsuccessAlertContract:boolean
  isRemindLoading: boolean;
  private readonly legacyPopupTriggerKey = 'showLegacyBexioUpdatePopup';
  constructor(private router: Router,private layoutService: LayoutService,private i18nService: I18nService,private commonService:CommonService,private userService: UserService,
    private tutorialService: TutorialEventsService,private _eref: ElementRef,private httpClient: HttpClient,private sharedLayout:SharedLayoutService,private emitService: EmitService,private _appService: AppService,private _sanitizer: DomSanitizer) {
    this.lanId = this.commonService.getCurrentLanguageCode();
    this.langChangeSubscription = this.i18nService.langChangeEvent.subscribe(langObj =>
      setTimeout(() => {
        this.onLangChange(langObj);
      },500));
    if ((this.router.url.indexOf("/ebill/") !== -1)) {
      this.ediMenuSelected = false;
      this.ebillMenuSelected = true;
    }
    else{
      this.ediMenuSelected = true;
      this.ebillMenuSelected = false;
    }
    let style =  this.commonService.getCookie(this.commonService.encrypt('styleCookie'));
    let styleTheme = this.commonService.decrypt(style)
    styleTheme ? this.layoutService.onSmartSkin(JSON.parse(styleTheme)):'';
    let status;
    setTimeout(() => {
      styleTheme?JSON.parse(styleTheme).name == 'smart-style-2' ? $("#themeStyle").prop("checked",true): $("#themeStyle").prop("checked",false):'';

    });
    let permissionCookie = this.commonService.getCookie(environment.permissions);
    this.pagePermission = this.commonService.decrypt(decodeURIComponent(permissionCookie)).split(',');
    this.haseBillPermission = this.pagePermission.toString().indexOf("ebill.settings.")!=-1 ? true : false;
    this.hasEDIPermission = this.pagePermission.toString().indexOf("gate2b.settings.*") != -1 ? true : false;
    this.emitService.newDistEvent.subscribe(data=>{
      if(data){
        this.buildAlert = this.i18nService.getTranslation('build_alert');
        this.newBuild.show();
      }

    })
  }
  onLangChange(langObj: any) {
    langObj.isHandled = true;
    this.lanId = this.commonService.getCurrentLanguageCode();
    this.loadedDarkOptions = false;
    this.loadedDarkprofile = false;
    this.loadedLightprofile = false;
    if( this.langaugeChanged ){
      setTimeout(() => {
        this.loadDarkProfile();
        this.loadDarkOptions();
      }, 1000);

    }
    this.tutorialService.editUser(true);
    this.langaugeChanged = true;
  }

  selectActivity(data){ 
    // this.activitySelected = data;
    if(data.type=='notification'){
      this.notificationSelected = data.value;
    }
    else
      this.activitySelected = data.value;
  }
  selectFullScreen(data){
    this.fullScreenSelected = data;
  }

  ngOnInit() {
    // if(this.hasEDIPermission){
    //   this.existDocumentDetails()
    // }
    // else{
    //   this._appService.setContract('true'); 
    // }
    setTimeout(() => {
      this.showLegacyUpdatePopupIfNeeded();
    }, 0);
    this._appService._navigationNotify$.subscribe(data => {
      if(data.toString()=='true') {
        this.ediMenuSelected = false;
        this.ebillMenuSelected = true;
      }else if(data.toString()=='false') {
        this.ediMenuSelected = true;
        this.ebillMenuSelected = false;
      }
    })
    this.store = this.layoutService.store;
    let skins = this.store.skins;
    for (let i = 0; i < skins.length; i++) {
      if(skins[i].name == 'smart-style-1')
        this.dark = skins[i];
      if(skins[i].name == 'smart-style-2')
        this.light = skins[i];
    }
    setTimeout(() => {
      this.loadDarkProfile();
      this.loadDarkOptions();
    }, 1000);
    // this.loadLightOptions();
    // this.loadLightProfile();
    this.buildAlert = this.i18nService.getTranslation('build_alert');

  }
  private showLegacyUpdatePopupIfNeeded(): void {
    // if (sessionStorage.getItem('legacyPopupShown') !== 'true') {
    //   sessionStorage.setItem('legacyPopupShown', 'true');
      setTimeout(() => {
        this.legacyUpdateModal?.show();
      }, 0);
    // }
  }
  closeLegacyUpdatePopup(): void {
    this.legacyUpdateModal?.hide();
  }
  goToLegacyUpdateApp(): void {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const domain = parts.slice(-2).join('.');
    const newUrl = `https://gate2b-bexio.${domain}/dashboard?startTour=true`;
    window.open(newUrl, '_blank'); // opens in new tab
   // window.location.href = newUrl;
    this.legacyUpdateModal?.hide();
  }
  loadDarkOptions(): void {
    if (this.loadedDarkOptions) return;
    const script = document.createElement('script');
    // script.src = 'assets/webComponent/options.js';
    script.src = environment.WC_APPS;
    // "https://wc.io-procurement.com/subscribedApps/main.js";
    document.body.appendChild(script);
    this.loadedDarkOptions = true;
    const content = document.getElementById('webComponetsOptions');
    this.lanId = this.commonService.getCurrentLanguageCode();
    let optiondata: any = { isWork: true, lang: this.lanId };
    optiondata = JSON.stringify(optiondata);
    content.innerHTML = `<custom-button optiondata='${optiondata}'></custom-button>`;
  }
  loadDarkProfile(): void {
    if (this.loadedDarkprofile) return;
    const script = document.createElement('script');
    // script.src = 'assets/webComponent/profile.js';
    script.src = environment.WC_PROFILE;
    document.body.appendChild(script);
    this.loadedDarkprofile = true;
    const content = document.getElementById('webComponetsProfile');
    this.lanId = this.commonService.getCurrentLanguageCode();
    // this.userService.userData().subscribe(res=>{
    //   if(res['status']){
    //     let user = res['data'];
    //     localStorage.setEncryptedItem("userData", JSON.stringify(user));
    //     this.company = user[0].companyDetails[0].legalname;
        let profileData: any = {lang: this.lanId};
    profileData = JSON.stringify(profileData);
    content.innerHTML = `<profile-button profiledata='${profileData}'></profile-button>`;
    //   }

    // })
  }

  searchMobileActive = false;

  toggleSearchMobile(){
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  onSubmit() {
    this.router.navigate(['/miscellaneous/search']);

  }

  routeToProfile(){
    this.router.navigate(['/profile']);
  }
  onSelectTheme(e){

    if(e.currentTarget.checked == true){
      this.commonService.setCookie(this.commonService.encrypt(environment.styleCookie),this.commonService.encrypt(JSON.stringify(this.light)),10000,environment.cookieDomain,'/')
      this.layoutService.onSmartSkin(this.light)
      $('.menuIconsOption').siblings('div').first().removeClass(this.dark.name).addClass(this.light.name);
      $('.menuIcons').siblings('div').first().removeClass(this.dark.name).addClass(this.light.name);
      // document.getElementById("webComponetsOptionsLight").style.display = "block"
      // document.getElementById("webComponetsOptions").style.display = "none"
      // document.getElementById("webComponetsProfileLight").style.display = "block"
      // document.getElementById("webComponetsProfile").style.display = "none"
    }
    else{
      this.layoutService.onSmartSkin(this.dark)
      this.commonService.setCookie(this.commonService.encrypt(environment.styleCookie),this.commonService.encrypt(JSON.stringify(this.dark)),10000,environment.cookieDomain,'/')

      $('.menuIconsOption').siblings('div').first().removeClass(this.light.name).addClass(this.dark.name);
      $('.menuIcons').siblings('div').first().removeClass(this.light.name).addClass(this.dark.name);
      // document.getElementById("webComponetsOptions").style.display = "block"
      // document.getElementById("webComponetsOptionsLight").style.display = "none"
      // document.getElementById("webComponetsProfile").style.display = "block"
      // document.getElementById("webComponetsProfileLight").style.display = "none"
    }
    this.loadedDarkprofile = false;
    // $('profile-button').remove();
    // this.loadDarkProfile();
    this.loadedDarkOptions = false;
    // $('custom-button').remove();
    // this.loadDarkOptions();
  }

  loadEdiMenu(){
    this.ediMenuSelected = true;
    this.ebillMenuSelected = false;
    this.sharedLayout.triggerAppDataChange({ code: 'edi', showDefault: true});
    this.router.navigate(['/edi']);
  }
  loadEbillMenu(){
    this.ediMenuSelected = false;
    this.ebillMenuSelected = true;
    this.sharedLayout.triggerAppDataChange({ code: 'ebill', showDefault: true});
    localStorage.getEncryptedItem('hasBiller') == 'true' ? this.router.navigate(['/ebill/invoices']) :this.router.navigate(['/ebill/biller']);
  }
  clearCache() {
    localStorage.clear();
    let cookies = document.cookie.split("; ");
    for (let c = 0; c < cookies.length; c++) {
      let d = window.location.hostname.split(".");
      while (d.length > 0) {
        let cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
        let p = location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        };
        d.shift();
      }
    }
    location.reload()
  }
  //   getdocumentdownloadDetails(){
  //     this.pdfFileName=this.i18nService.getTranslation('dashboard_contract');
  //     let formData = new FormData();
  //     formData.append('partyId',localStorage.getEncryptedItem('partyID'));
  //     let object = this.commonService.createObject(formData);
  //     let token = this.commonService.createToken(object);
  //     this._appService.downloadDocument(formData).subscribe( data => {
  //       if(data.status)
  //       {

  //         let downloaddocument=data.data;
  //                   this.pdfglinkSource = downloaddocument;
  //                   this.isXml = false;
  //                     this.imageData = this._sanitizer.bypassSecurityTrustResourceUrl(this.pdfglinkSource);
  //                   this.previewSearchModal.show();
  //                   var blob = new Blob([data.data], {
  //                     type: 'application/pdf'
  //                   });
  //                   const url = this._sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
  //                   this.filePath = url;

  //          }
  //       })
  // }
  // saveContractDetails(){
  //   let formData = new FormData();
  //   formData.append('partyId',localStorage.getEncryptedItem('partyID'));
  //   formData.append('accId',localStorage.getEncryptedItem('accId'));
  //   formData.append('base64',this.pdfglinkSource)
  //   this.ispreviewLoading = true;
  //   this.showPreviewLoader = true;
  //   this._appService.saveContractDetails(formData).subscribe( data => {
  //   if(data['status']){
  //     this.showErrorContractMsg = true;
  //     this.ShowContract = false;
  //     this.closeContract = false;
  //     this.ispreviewLoading = false;
  //     this.showPreviewLoader = false;
  //     this.isSuccess = true;
  //     this.alertMessage = data['message'];

  //     setTimeout(() => {
  //       this.showsuccessAlertContract = true;
  //       this.previewSearchModal.hide();

  //       setTimeout(() => {
  //       },500);
  //     }, 
  //     );
  //   }
  //   else{
  //     this.showErrorContractMsg = false; 
  //     this.previewSearchModal.hide();
  //     this.showPreviewLoader = false;
  //     this.ispreviewLoading = false;
  //     this.isSuccess = false;
  //     this.showsuccessAlertContract = true;
  //     this.alertMessage = data['message'];
  //     this.isErrors =true;

  //     // this.loadDirectionAndEdi();

  //     setTimeout(() => {
  //       this.showsuccessAlertContract = false;
  //       this.isErrors =false;
  //       this.previewSearchModal.show();
  //     },3000);
  //   }
  //   }, error=>{
  //     this.showsuccessAlertContract = true;
  //     this.isErrors =true;
  //     this.previewSearchModal.hide()

  //   if (error["status"] == 500){
  //     this.ispreviewLoading = false;
  //     this.showPreviewLoader = false;
  //     this.showsuccessAlertContract = true;
  //     this.isErrors =true;
  //     this.alertMessage = error.error.message;
  //   }
  //   else{
  //     this.showsuccessAlertContract = true;
  //     this.isErrors =true;
  //     this.alertMessage = 'something_went_wrong';
  //     this.ispreviewLoading = false;
  //     this.showPreviewLoader = false;
  //   }
  // }
  //   )
  // }

  // existDocumentDetails(){
  //   let formData = new FormData();
  //   formData.append('partyId',localStorage.getEncryptedItem('partyID'));
  //   this._appService.existContract(formData).subscribe( data => {
  //     if(data['status'])
  //     {
  //       if(localStorage.getEncryptedItem('isContractRemindLater')!='true')
  //         this.getdocumentdownloadDetails();
  //     }
  //     else{
  //       this._appService.setContract('true'); 
  //     }
  //     })

  // }

  onClickNewWindow() {

let iframe = "<body style='margin:0;padding:0'><iframe width='100%' height='100%'src='"+ this.pdfglinkSource +"'></iframe></body>"
    let childWindow = window.open();
    childWindow.document.open();
    childWindow.document.write(iframe);
    childWindow.document.close();
  }
  goToAdmin() {
  window.open(environment.ADMIN_URL+'contracts', '_self')
    return false;
  }
  // closeSuccessContract(){
  //   this._appService.setContract('true');
  //   this.isSuccess = false
  //   this.showsuccessAlertContract = false;
  //   this.isErrors = false
  //   this.ShowContract = false
  //   this.closeContract = false
  // }
  // contractRemindLater() {
  //   this.isRemindLoading = true;
  //   localStorage.setEncryptedItem('isContractRemindLater', 'true');
  //   let formData = new FormData();
  //   formData.append("partyId", localStorage.getEncryptedItem('partyID'));
  //   formData.append("language", this.lanId);
  //   formData.append("email", JSON.parse(localStorage.getEncryptedItem('userData'))[0].email);
  //   formData.append("permission", 'gate2b.dashboard.remindContract');
  //   let objectUser = this.commonService.createObject(formData);
  //   let tokenUser = this.commonService.createToken(objectUser);
  //   let encryptedTokenUser = this.commonService.encrypt(tokenUser);
  //   let encrDataUser = new FormData();
  //   encrDataUser.append("encrToken", encryptedTokenUser);
  //   this._appService.contractRemindLater(encrDataUser).subscribe( data => {
  //     if(data['status']){
  //       this.isRemindLoading = false;
  //       this.previewSearchModal.hide()
  //       // this.loadDirectionAndEdi()
  //     }
  //   })
  // }
}
